/**
 * Feature Tabs: WAI-ARIA tabs (automatic activation). The server renders the first tab active, so content works without
 * JS; panels are stacked in one grid cell, so switching never changes the section height.
 */
(() => {
  const init = (root) => {
    const list = root.querySelector('[role="tablist"]');
    const tabs = Array.from(root.querySelectorAll('[data-feature-tabs-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-feature-tabs-panel]'));

    if (tabs.length < 2) {
      return;
    }

    const select = (index, focus) => {
      tabs.forEach((tab, i) => {
        const isActive = i === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.tabIndex = isActive ? 0 : -1;
        panels[i]?.classList.toggle('is-active', isActive);
      });

      if (focus) {
        tabs[index].focus({ preventScroll: true });
        // Keep the selected tab visible in the (sideways scrolling) tab row without scrolling the page.
        const tab = tabs[index].getBoundingClientRect();
        const box = list.getBoundingClientRect();
        if (tab.left < box.left) {
          list.scrollLeft += tab.left - box.left;
        } else if (tab.right > box.right) {
          list.scrollLeft += tab.right - box.right;
        }
      }
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(index, false));
      tab.addEventListener('keydown', (event) => {
        const last = tabs.length - 1;
        const next = {
          ArrowRight: index === last ? 0 : index + 1,
          ArrowLeft: index === 0 ? last : index - 1,
          Home: 0,
          End: last,
        }[event.key];

        if (next !== undefined) {
          event.preventDefault();
          select(next, true);
        }
      });
    });
  };

  const boot = () => document.querySelectorAll('[data-feature-tabs]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
